import {BannerCfgJs} from 'OK/banners/bannerNew/config/BannerCfgJs';
import {createLog} from 'OK/banners/bannerNew/utils/BannerCommon';
import {BufferedCommandJs} from 'OK/banners/bannerNew/utils/BufferedCommandJs';
import {RequestJs} from 'OK/banners/bannerNew/BannerModelJs';
import type { TBaseParams, IBannerTransportJs } from "OK/banners/bannerNew/transport/IBannerTransportJs";
import * as logger from 'OK/logger';
import {BannerPlaceListenersProxyJs} from "OK/banners/bannerNew/BannerPlaceListenersProxyJs";
import {getRbSyncData} from "OK/rbUtils";

declare const window: Record<string, unknown>;

const log = createLog('BannerTransportJs');

const NAME = 'name';

const HTML = 'html';

const callBackName: string = 'rb_tadq_' + Date.now();

const JSONP_TTL = 5000;

let lastRequestId = 1;

let callbackMap: Record<string, CallbackJs> = {};

let runningJSONP: Record<string, number> = {};

let respNum = 0;

let pending: JSONP[] = [];

let lastJSONPId = 0;

let req2jsonp = new Map<string, string>();

let req2ReqIdHolder = new Map<string, ReqId>();

const CLICK_TIMEOUT = 100;

const bannerPlaceListenersProxy = BannerPlaceListenersProxyJs.getInstance();

let instance: BannerTransportJs | null = null;

export class BannerTransportJs implements IBannerTransportJs {
    protected requests: RequestCollectorJs;
    protected flushCommand: BufferedCommandJs;

    constructor() {
        this.requests = new RequestCollectorJs();
        this.flushCommand = new BufferedCommandJs(
            () => {
                return BannerCfgJs.getMultiLoad()?.maxLatency!;
            },
            () => {
                return BannerCfgJs.getMultiLoad()?.heartbeatDelay!;
            },
            this.flush.bind(this)
        );
    }

    protected flush() {
        const baseUrl = BannerCfgJs.getMultiLoad()?.url;

        /* Собираем номера всех запрашиваемых слотов */
        let q: string[] = [];
        const pendingObject: { [key: number | string]: ReqId } = this.requests.requests;
        const pendingKeys = Object.getOwnPropertyNames(pendingObject);
        let reqIds: Array<ReqId> = [];
        if (!pendingKeys.length) {
            /* Не требуется отсылать запрос, если нет очереди ожидающих */
            return;
        }
        pendingKeys.forEach(key => {
            const value: ReqId = pendingObject[key];

            /* Запоминаем список всех сгененированных "номеров" запроса */
            reqIds.push(value);

            /*
             * entry.getKey() — номер слота, он будет возвращаться в JSON как поле 'slot'
             * ? — всё, что после знака есть специальные параметры для слота
             * n — выделяется из специальных параметров для слота, так как значение будет возвращаться в JSON как поле 'name'
             * entry.getValue() — сгенерированный "номер" запроса, он и будет возвращаться и мы можем определить на какой запрос получили ответ RB
             */
            const query = `${key}?n=${value.id}`;
            /*
             * Не забываем кодировать query ( ?n= -> %3Fn%3D ),
             * иначе поломаем корректный парсинг параметров запроса
             */
            q.push("q=" + encodeURIComponent(query));
            /*
             * Логируем вызов РБ
             * param1 — текущая страница
             * param2 — номер слота
             */
            var modelId = (OK.getCurrentDesktopModelId && OK.getCurrentDesktopModelId()) || 'nogwt';
            logger.success('ad', modelId, 'js_adq.' + key);
        });

        log('flush, q', q);

        BannerTransportJs.appendCookielessUserSyncParameters(this.requests.params);

        /*
         * Формируем итоговый УРЛ, baseUrl + "?callback=" + callBackName + (Площадка ОК) + (соединяем все номера слотов+специальные параметры слотов) + (общие параметры всех запросов в RB (персональная инфа для таргеттинга)
         */
        const url = `${baseUrl}?callback=${callBackName}&_SITEID=163&${q.join('&')}&${BannerTransportJs.encodeParams(this.requests.params)}`;
        /* Очистка запросов, ожидающих  */
        this.requests.clear();
        log('flush', url, reqIds);
        // Добавление запроса в очередь
        this.addJSONPRequest(url, reqIds);
    }

    /* Что это и зачем см в RbSyncBlock.java , https://confluence.mail.ru/display/RB/Cookieless+User+Sync */
    static appendCookielessUserSyncParameters(params: TBaseParams) {
        const rbSyncData = getRbSyncData((message, error) => {
            log(message, error!);
        });

        Object.assign(params, rbSyncData)
    }

    sendJSONP(container: HTMLElement | null, reqId: ReqId, slot: number, params: TBaseParams) {
        if (!this.requests.addRequest(reqId, slot, params)) {
            this.flushCommand.force();
            this.requests.addRequest(reqId, slot, params);
        }
        this.flushCommand.invoke();
    }

    sendRequest(slot: number, params: TBaseParams, request: RequestJs) {
        if (!BannerCfgJs.getMultiLoad()?.adqEnabled) {
            return;
        }
        const reqId = buildReqId();
        callbackMap[reqId] = new CallbackJs(reqId, request);
        const reqIdHolder = new ReqId(reqId, request.bannerPlace!, slot)
        this.sendJSONP(null, reqIdHolder, slot, params);
    }

    addJSONPRequest(jsonpUrl: string, reqIds: Array<ReqId>) {
        if (canSendJSONP()) {
            log('addJSONPRequest now', jsonpUrl, reqIds);
            sendJSONPRequest(jsonpUrl, reqIds);
        } else {
            log('addJSONPRequest queue', jsonpUrl, reqIds);
            this.queueJSONPRequest(jsonpUrl, reqIds);
        }
    }

    queueJSONPRequest(jsonpUrl: string, reqIds: Array<ReqId>) {
        pending.push(new JSONP(jsonpUrl, reqIds));
    }

    sendClick(clickUrl: string, params: TBaseParams) {
        setTimeout(() => {
            const img = new Image();
            img.src = `${clickUrl}?${BannerTransportJs.encodeParams(params)}`;
        }, CLICK_TIMEOUT);
    }

    static encodeParams(params: TBaseParams) {
        const keys = Object.getOwnPropertyNames(params);
        if (keys.length) {
            const strings: string[] = [];
            keys.forEach(key => {
                const val = params[key];
                if (val !== undefined && val !== null) {
                    strings.push(`${key}=${encodeURIComponent(val)}`);
                }
            });
            return strings.join("&");
        } else {
            return "";
        }
    }

    static appendParam(params: TBaseParams, name: string, value: string|number) {
        if (value !== null) {
            switch (typeof value) {
                case 'string':
                    params[name] = value;
                    break;
                case 'number':
                    params[name] = value + '';
                    break;
            }
        }
        return params;
    }

    static getInstance() {
        if (instance === null) {
            instance = new BannerTransportJs();
        }
        return instance;
    }
}

function buildWrapperId(reqId: string): string {
    return "blwrapper_" + reqId;
}

function buildReqId(): string {
    // N.B. adq не может обрабатывать ничего кроме латиницы и цифр, так что никаких прочих символов здесь
    return "nbnr" + (lastRequestId++);
}

function cleanupJSONP(jsonpId: string) {
    try {
        delete runningJSONP[jsonpId];

        const elementId = buildWrapperId(jsonpId);
        const script = document.getElementById(elementId);

        if (script !== null && script.parentNode) {
            script.parentNode.removeChild(script);
            respNum ++;
        }
        if (canSendJSONP() && pending.length) {
            const jsonp = pending.shift();
            sendJSONPRequest(jsonp?.url!, jsonp?.reqIds!);
        }
    } catch (e) {
        logger.errorEx(e as Error, "BannerTransport", "cleanup_");
        throw e;
    }
}

function canSendJSONP() {
    return Object.getOwnPropertyNames(runningJSONP).length < (BannerCfgJs.getMultiLoad()?.concurrency!);
}

function isCallbacksEnabled() {
    return BannerCfgJs.getInstance().callbacksEnabled;
}

function sendJSONPRequest(jsonpUrl: string, reqIds: Array<ReqId>) {
    log('sendJSONPRequest', jsonpUrl, reqIds);
    const jsonpId = (lastJSONPId++) + '';

    reqIds.forEach(reqId => {
        req2jsonp.set(reqId.id, jsonpId);
        req2ReqIdHolder.set(reqId.id, reqId);
    });

    setupJSONP(jsonpId, jsonpUrl, reqIds);
}

function handleError(jsonpId: string) {
    for (let [key, value] of req2jsonp) {
        if (value == jsonpId) {
            handleResponse(key, '');
        }
    }
}

function setupJSONP(jsonpId: string, jsonpUrl: string, reqIds: Array<ReqId>) {
    let script = document.createElement("script");
    script.type = "text/javascript";
    script.src = `${jsonpUrl}&nn=${respNum}`;
    script.async = true;
    script.id = buildWrapperId(jsonpId);
    script.onerror = function (event) {
        handleError(jsonpId);
    };

    document.head.appendChild(script);

    runningJSONP[jsonpId] = Date.now();

    if (isCallbacksEnabled()) {
        log('script tag appended, requests: ' + reqIds.toString());
        try {
            reqIds.forEach(reqId => {
                bannerPlaceListenersProxy.onRequest(reqId)
            });
        } catch (ex) {
            logger.errorEx(ex as Error, 'AdqBannerTransport', 'script_on_request');
        }

        const scriptEventListener = new ScriptOnLoadEventListener(script, reqIds);
        script.addEventListener('load', scriptEventListener);
        script.addEventListener('error', scriptEventListener);
    }
}

function handleAdq(jso: Record<string, string>[]) {
    log('handleAdq', jso);
    if (jso === null) {
        logger.errorEx(new Error("ADQ null response"), "BannerTransport", "adq-callback");
        return;
    }
    try {
        /* adq декларирует возврат массива */
        const size = jso.length;
        if (size === 0) {
            logger.errorEx(new Error("ADQ empty array"), "BannerTransport", "adq-array");
            return;
        }
        /* Итерация по массиву */
        for (let idx = 0; idx < size; idx++) {
            const obj: Record<string, string> = jso[idx];
            /* Элементом массива должен быть JSON объект */
            if (obj !== null && typeof obj === 'object') {
                const id = obj[NAME];
                if (!id) {
                    /* Параметр name определяет на какой запрос был получен ответ от RB */
                    logger.errorEx(new Error("ADQ invalid 'name'"), "BannerTransport", "adq-name");
                    continue;
                }

                const response = obj[HTML];
                if (response === undefined) {
                    /* Параметр response содержит ответ от RB, который должен быть использован как содержимое для вставки баннера */
                    logger.errorEx(new Error("ADQ invalid 'html'"), "BannerTransport", "adq-html");
                    continue;
                }

                const reqId = req2ReqIdHolder.get(id);
                req2ReqIdHolder.delete(id);
                if (!isCallbacksEnabled()) {
                    /* Обрабатываем ответ через существующий механизм */
                    handleResponse(id, response);
                } else {
                    try {
                        handleResponse(id, response);
                        if (reqId != null) {
                            bannerPlaceListenersProxy.onAdsSuccess(reqId);
                        }
                    } catch (ex) {
                        logger.errorEx(ex as Error, 'AdqBannerTransport', 'handleResponse');
                        if (reqId != null) {
                            bannerPlaceListenersProxy.onScriptError(reqId);
                        }
                    }
                }
            } else {
                logger.errorEx(new Error("ADQ invalid item"), "BannerTransport", "adq-item");
            }
        }
    } catch (e) {
        logger.errorEx(new Error("ADQ unexpected"), "BannerTransport", "adq-unknown");
    }
}

window[callBackName] = handleAdq;

function handleResponse(id: string, response: string) {
    log('handleResponse', {
        id: id,
        response: response
    });
    try {
        const callback = callbackMap[id];
        if (callback) {
            callback.handleResponse(response);
        }
    } catch (ex) {
        logger.errorEx(ex as Error, "BannerTransport", "callback");
    }
    try {
        const jsonpId = req2jsonp.get(id);
        req2jsonp.delete(id);
        if (jsonpId) {
            cleanupJSONP(jsonpId);
        }
    } catch (ex) {
        logger.errorEx(ex as Error, "BannerTransport", "after_callback");
    }
}

setInterval(() => {
        try {
            let expired: string[] = [];
            Object.getOwnPropertyNames(runningJSONP).forEach(jsonpId => {
                const elapsedMillis = Date.now() - runningJSONP[jsonpId];
                if (elapsedMillis > JSONP_TTL) {
                    expired.push(jsonpId);
                }
            });
            expired.forEach(jsonpId => {
                handleError(jsonpId);
            });
        } catch (e) {
            logger.errorEx(e as Error, "BannerTransport", "cleanup");
        }
}, JSONP_TTL);

// =====================================================
// =================== CallbackJs ======================
// =====================================================

class CallbackJs {
    id: string;
    request: RequestJs;

    constructor(id: string, request: RequestJs) {
        this.id = id;
        this.request = request;
        this.request.setCancellationListener(this);
    }

    handleResponse(response: string) {
        this.request.handleResponse(response);
    }

    onCancel() {
        delete callbackMap[this.id];
    }
}

// =====================================================
// ====================== JSONP ========================
// =====================================================

class JSONP {
    url: string;
    reqIds: Array<ReqId>;

    constructor(url: string, reqIds: Array<ReqId>) {
        this.url = url;
        this.reqIds = reqIds;
    }
}

// =====================================================
// =============== RequestCollectorJs ==================
// =====================================================

class RequestCollectorJs {
    requests: { [key: number]: ReqId };
    params: TBaseParams;

    constructor() {
        this.requests = {};
        this.params = {};
    }

    clear() {
        this.requests = {};
        this.params = {};
    }

    addRequest(reqId: ReqId, slot: number, params: TBaseParams): boolean {
        if (this.requests.hasOwnProperty(slot)) {
            return false;
        } else {
            let intersection = Object.getOwnPropertyNames(this.params);
            intersection = intersection.filter(value => {
                return params.hasOwnProperty(value);
            });

            for (let i = 0; i < intersection.length; i++) {
                const key = intersection[i];
                if (params[key] !== this.params[key]) {
                    return false;
                }
            }

            this.requests[slot] = reqId;

            Object.getOwnPropertyNames(params).forEach(key => {
                this.params[key] = params[key];
            });

            return true;
        }
    }
}

export class ReqId {
    id: string;
    bannerPlace: string;
    slot: number;
    transport = 'js_adq';

    constructor(id: string, bannerPlace: string, slot: number) {
        this.id = id;
        this.bannerPlace = bannerPlace;
        this.slot = slot;
    }

    setTransport(transport: string) {
        this.transport = transport;
        return this;
    }

    toString() {
        return 'ReqId{' +
            'id=\'' + this.id + '\'' +
            ', bannerPlace=\'' + this.bannerPlace + '\'' +
            ', slot=' + this.slot +
            ', transport=\'' + this.transport + '\'' +
            '}';
    }
}

class ScriptOnLoadEventListener {
    script: HTMLScriptElement;
    reqIds: Array<ReqId>;

    constructor(script: HTMLScriptElement, reqIds: Array<ReqId>) {
        this.script = script;
        this.reqIds = reqIds;
    }

    handleEvent(e: Event) {
        log('script on \'' + e.type + '\' event handling, requests: ' + this.reqIds.toString());
        if (e.type === 'load') {
            try {
                this.reqIds.forEach(reqId => {
                    bannerPlaceListenersProxy.onLoadSuccess(reqId)
                });
            } catch (ex) {
                logger.errorEx(ex as Error, "AdqBannerTransport", "script_on_load");
            }
        } else if (e.type === 'error') {
            try {
                this.reqIds.forEach(reqId => {
                    bannerPlaceListenersProxy.onLoadError(reqId)
                });
            } catch (ex) {
                logger.errorEx(ex as Error, "AdqBannerTransport", "script_on_error");
            }
        }
        this.script.removeEventListener('load', this);
        this.script.removeEventListener('error', this);
    }
}
